"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeStickyPriceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_services_1 = require("@athena-portal/journey-services");
var HomeUtils_1 = require("./HomeUtils");
var AnnualHomeStickyPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeStickyPriceWidget, _super);
    function AnnualHomeStickyPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.homeUtils = new HomeUtils_1.HomeUtils();
        _this.visibilityBreakPoint = 250;
        _this.showOnScroll = function () {
            if (_this.state.visibilityClass === "d-none") {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
            }
            else {
                if (window.scrollY > _this.visibilityBreakPoint) {
                    _this.setState({ visibilityClass: "show" });
                }
                else {
                    _this.setState({ visibilityClass: "hide" });
                }
            }
            var tierTableElements = document.getElementsByClassName("tier-table");
            if (tierTableElements.length > 0) {
                var tierTable = tierTableElements[0];
                var tierRect = tierTable.getBoundingClientRect();
                if (tierRect.top <= 0 && tierRect.bottom >= 0) {
                    _this.setState({ showTierPremiums: true });
                }
                else {
                    _this.setState({ showTierPremiums: false });
                }
            }
        };
        _this.state = {
            visibilityClass: "d-none",
            showTierPremiums: false,
            initialCoverTier: _this.props.interaction.coverTier,
            tierWasOnceChanged: false
        };
        window.addEventListener("scroll", _this.showOnScroll);
        return _this;
    }
    AnnualHomeStickyPriceWidget.prototype.render = function () {
        var cssClass = this.getSetting("cssClass", "");
        return ((0, jsx_runtime_1.jsx)("div", { className: "sticky-price ".concat(cssClass, " quote ").concat(this.state.visibilityClass).concat(this.state.showTierPremiums ? " tiers pt-0" : ""), children: (0, jsx_runtime_1.jsx)("div", { className: this.state.showTierPremiums ? "container" : "sticky-price-background", children: this.state.showTierPremiums ?
                    this.renderTierTables() :
                    this.renderSelectedPremium() }) }));
    };
    AnnualHomeStickyPriceWidget.prototype.renderSelectedPremium = function () {
        var premium;
        var wording;
        var tierNotSelectedAndEligibleForMultipleTiers = !this.props.interaction.coverTier && (0, commonFunctions_1.getHomeEligibleTiers)(this.props.interaction).length > 1;
        if (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
            premium = this.props.interaction.factors.annualPremium;
            wording = " / year*";
        }
        else {
            premium = this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
            wording = " / month*";
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "d-inline-block", children: [tierNotSelectedAndEligibleForMultipleTiers &&
                    (0, jsx_runtime_1.jsx)("span", { className: "fs-18 mr-1", children: "From " }), (0, commonFunctions_1.getAmountToDisplay)(premium), (0, jsx_runtime_1.jsx)("span", { className: "fs-18", children: wording })] }));
    };
    AnnualHomeStickyPriceWidget.prototype.renderTierTables = function () {
        var _this = this;
        var tiers = new Map();
        var renderBronzeTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.BRONZE_TIER, this.props.interaction.tieredUnderwritingResult);
        var renderSilverTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.SILVER_TIER, this.props.interaction.tieredUnderwritingResult);
        var renderGoldTier = (0, commonFunctions_1.isTierNotDeclined)(services_1.GOLD_TIER, this.props.interaction.tieredUnderwritingResult);
        var tierHidden = "";
        if (!renderBronzeTier) {
            tierHidden = " bronze-hidden";
        }
        if (!renderSilverTier) {
            tierHidden = " silver-hidden";
        }
        if (!renderGoldTier) {
            tierHidden = " gold-hidden";
        }
        if (renderBronzeTier) {
            tiers.set(services_1.BRONZE_TIER, "".concat(services_1.resourcesHelper.PRODUCT_TIER_1));
        }
        if (renderSilverTier) {
            tiers.set(services_1.SILVER_TIER, "".concat(services_1.resourcesHelper.PRODUCT_TIER_2));
        }
        if (renderGoldTier) {
            tiers.set(services_1.GOLD_TIER, "".concat(services_1.resourcesHelper.PRODUCT_TIER_3));
        }
        var rows = [];
        tiers.forEach(function (tierName, code) {
            rows.push(_this.renderTierPremium(code, tierName));
        });
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-content", children: (0, jsx_runtime_1.jsxs)("div", { className: "row mr-0 ml-0 sticky-tiers sticky-tiers-home" + tierHidden, children: [(0, jsx_runtime_1.jsx)("div", { className: "col-4" }), rows] }) }));
    };
    AnnualHomeStickyPriceWidget.prototype.renderTierPremium = function (tier, tierName) {
        var _this = this;
        var factors = this.props.interaction.factors;
        var premiumType = factors.premiumType;
        var isSelected = this.props.interaction.coverTier === tier;
        var wrapperClass = isSelected ? "background-color-primary" : "";
        var annualPremium = this.homeUtils.getAnnualPremium(tier, factors);
        var monthlyPremium = this.homeUtils.getMonthlyPremium(tier, factors);
        return ((0, jsx_runtime_1.jsx)("div", { className: "col ".concat(wrapperClass), onClick: function (event) { return _this.handleChange(tier); }, children: (0, jsx_runtime_1.jsx)("div", { className: "font-semi-bold tier-premium-display", children: premiumType === "annual" ?
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "custom-radiobutton-container", children: (0, jsx_runtime_1.jsx)("input", { className: "custom-radiobutton", type: "radio", name: this.props.question.name, value: tier, id: this.props.question.name + tier, checked: isSelected }, tier + "input") }), (0, jsx_runtime_1.jsx)("div", { className: "tier-name home", children: tierName }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, commonFunctions_1.getAmountToDisplay)(annualPremium), (0, jsx_runtime_1.jsx)("p", { className: "font-light text-color-dark", children: " / year*" })] })] }) :
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "custom-radiobutton-container", children: (0, jsx_runtime_1.jsx)("input", { className: "custom-radiobutton", type: "radio", name: this.props.question.name, value: tier, id: this.props.question.name + tier, checked: isSelected }, tier + "input") }), (0, jsx_runtime_1.jsx)("div", { className: "tier-name home", children: tierName }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, commonFunctions_1.getAmountToDisplay)(monthlyPremium), (0, jsx_runtime_1.jsx)("p", { className: "font-light text-color-dark", children: " / month*" })] })] }) }) }));
    };
    AnnualHomeStickyPriceWidget.prototype.handleChange = function (selectedTier) {
        // only on renewal page, set bronze/silver fixed addons to blank values once if changing tier from gold - FAL-44341
        var renewalFirstSwitchFromGold = this.props.interaction.status === services_1.POLICY_STATUS_PENDING_RENEWAL_PENDING_UPDATE
            && !this.state.tierWasOnceChanged
            && this.state.initialCoverTier === services_1.GOLD_TIER
            && selectedTier !== services_1.GOLD_TIER;
        if (renewalFirstSwitchFromGold) {
            this.clearAddonsForSelection();
            this.setState({
                tierWasOnceChanged: true
            });
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("coverTier", selectedTier, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            this.executeEvent("change");
        }
        else {
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.previousTierLevel", this.props.interaction, this.props.interaction.coverTier);
            journey_services_1.ObjectManipulator.setFieldWithTrackChanges("coverTier", selectedTier, {
                interaction: this.props.interaction,
                initialInteraction: this.props.initialInteraction,
            });
            var prevTierLevel = this.props.interaction.uistate.annualHomeAddonsState.previousTierLevel;
            if (prevTierLevel !== services_1.GOLD_TIER) {
                this.recordPreviousAddons();
            }
            this.resetAddons(selectedTier === services_1.GOLD_TIER);
            this.updatePossessions(selectedTier === services_1.GOLD_TIER);
            this.executeEvent("change");
        }
    };
    AnnualHomeStickyPriceWidget.prototype.clearAddonsForSelection = function () {
        // exclude personal possessions if user initially had non-default(>2000) value in Gold tier
        var currentPersonalPossessionCoverLimit = this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit;
        // addonState values will be true if user has chosen personal possessions/addons in tier widget manually, in this case we don't want to clear the addon as it will be included in new bronze/silver calculated prices
        var addonState = this.props.interaction.uistate.annualHomeAddonsState;
        if (!(currentPersonalPossessionCoverLimit > 2000 || addonState.personalPossessionsCover === true)) {
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", this.props.interaction, null);
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", this.props.interaction, null);
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCoverMonthlyPrice", this.props.interaction, null);
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCoverPrice", this.props.interaction, null);
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionsCover", this.props.interaction, null);
        }
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.buildingAccidentalDamage", this.props.interaction, addonState.buildingAccidentalDamage ? true : null);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.contentsAccidentalDamage", this.props.interaction, addonState.contentsAccidentalDamagtrue ? true : null);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeLegalExpenses", this.props.interaction, addonState.homeLegalExpenses ? true : null);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeEmergency", this.props.interaction, addonState.homeEmergency ? true : null);
    };
    AnnualHomeStickyPriceWidget.prototype.resetAddons = function (isPremier) {
        var annualHomeAddonsState = this.props.interaction.uistate.annualHomeAddonsState;
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.buildingAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.contentsAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeLegalExpenses", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeEmergency", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeEmergency);
    };
    AnnualHomeStickyPriceWidget.prototype.recordPreviousAddons = function () {
        var annualHomeFixedAddons = this.props.interaction.annualHomeFixedAddons;
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", this.props.interaction, annualHomeFixedAddons.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", this.props.interaction, annualHomeFixedAddons.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", this.props.interaction, annualHomeFixedAddons.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", this.props.interaction, annualHomeFixedAddons.homeEmergency);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionCoverLimit", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionsCover", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionsCover);
    };
    AnnualHomeStickyPriceWidget.prototype.updatePossessions = function (switchToGold) {
        var currentPersonalPossessionCoverLimit = this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit;
        var goldPersonalPossessionCoverLimit = currentPersonalPossessionCoverLimit >= 2000 ? currentPersonalPossessionCoverLimit : 2000;
        var prevTierLevel = this.props.interaction.uistate.annualHomeAddonsState.previousTierLevel;
        // only non-gold tier values are saved on switch
        var prevNonGoldTierCoverLimit = this.props.interaction.uistate.annualHomeAddonsState.personalPossessionCoverLimit;
        var prevNonGoldTierCoverStatus = this.props.interaction.uistate.annualHomeAddonsState.personalPossessionsCover;
        if (switchToGold) {
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", this.props.interaction, switchToGold);
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", this.props.interaction, goldPersonalPossessionCoverLimit);
        }
        else if (prevTierLevel === services_1.GOLD_TIER && currentPersonalPossessionCoverLimit === 2000) {
            // gold tier has default minimum cover of 2000 when switching, so need to switch back to recorded previous tier values if they were less/no cover
            if (prevNonGoldTierCoverLimit <= 2000) {
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", this.props.interaction, prevNonGoldTierCoverStatus);
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", this.props.interaction, prevNonGoldTierCoverLimit);
            }
        }
    };
    return AnnualHomeStickyPriceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeStickyPriceWidget = AnnualHomeStickyPriceWidget;
//# sourceMappingURL=AnnualHomeStickyPriceWidget.js.map